import React, { Component } from "react";
import { connect } from "react-redux";
import ElementFocus from "features/Admin/components/ElementFocus";
import { adminGetAllGeneralParameters, adminPatchGeneralParameter } from "services/generalParameter";
import { searchCompanies } from "services/company";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon, Loader, Button, Modal, Header } from "semantic-ui-react";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import AgeForm from "features/Admin/GeneralParameters/Forms/AgeForm";
import UrlForm from "features/Admin/GeneralParameters/Forms/UrlForm";
import AvailabilityForm from "features/Admin/GeneralParameters/Forms/AvailabilityForm";
import ParamsForm from "features/Admin/GeneralParameters/Forms/ParamsForm";
import * as Yup from "yup";
import OtherForm from "./Forms/OtherForm";
import DegradationForm from "./Forms/DegradationForm";
import { getAllCenters } from "services/center";
import { adminGetAllCompanies } from "services/company";
import { adminGetCache, adminFlushCache } from "services/cache";
import { adminGetAllAnalysisLibrary } from "services/analysisLibrary";
import MotivationForm from "./Forms/MotivationForm";
import VideosLinksForm from "./Forms/VideosLinksForm";

const schemaValidation = Yup.object().shape({
	ageBabyBoyPrefix: Yup.string().required("Champ requis"),
	ageBabyGirlPrefix: Yup.string().required("Champ requis"),
	ageBabyOtherPrefix: Yup.string().required("Champ requis"),
	ageChildBoyPrefix: Yup.string().required("Champ requis"),
	ageChildGirlPrefix: Yup.string().required("Champ requis"),
	ageChildOtherPrefix: Yup.string().required("Champ requis"),
	ageManPrefix: Yup.string().required("Champ requis"),
	ageMaxBaby: Yup.number().required("Champ requis"),
	ageMaxChild: Yup.number().required("Champ requis"),
	ageOtherPrefix: Yup.string().required("Champ requis"),
	ageWomanPrefix: Yup.string().required("Champ requis"),
	urlCatalogExams: Yup.string().required("Champ requis"),
	urlTaking: Yup.string().required("Champ requis"),
	helpNurse: Yup.boolean().required("Champ requis"),
	lastUpdateCatalog: Yup.string(),
	urgencyPretreatementLimit: Yup.number(),
	live: Yup.boolean().required("Champ requis"),
	manualDegradation: Yup.boolean().required("Champ requis"),
	manualDegradationMessage: Yup.string().when("manualDegradation", {
		is: true,
		then: Yup.string().required("Champ requis"),
		else: Yup.string(),
	}),
	usualState: Yup.boolean().required("Champ requis"),
	checkMySecu: Yup.boolean().required("Champ requis"),
	videos: Yup.string(),
	analysesMarqTum: Yup.string(),
	analysesPregnant: Yup.string(),
});

class GeneralAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			openCache: false,
			cacheInfos: null,
			liveFactory: {
				list: this.props.centers.list.filter((c) => c.boxes && c.boxes.length > 0),
				listLabel: "Sélectionner un ou plusieurs centres",
				selectedLabel: "Centres actifs",
				value: [],
			},
			externalCompaniesFactory: {
				list: this.props.companies.list.data,
				listLabel: "Sélectionner une ou plusieurs sociétés",
				selectedLabel: "Sociétés disponibles pour les préleveurs externes",
				value: [],
			},
			analysesMarqTumFactory: {
				list: this.props.analyses.list.data,
				listLabel: "Sélectionner une ou plusieurs analyses",
				selectedLabel: "Analyses concernées pour les marqueurs tumoraux",
				value: [],
			},
			analysesPregnantFactory: {
				list: this.props.analyses.list.data,
				listLabel: "Sélectionner une ou plusieurs analyses",
				selectedLabel: "Analyses concernées pour les sérologies Grossesse",
				value: [],
			},
			videosLinks: [],
		};
	}
	updateFactoryValue = (newSelected, name) => {
		this.setState((prevState) => ({
			...prevState,
			[name]: {
				...prevState[name],
				value: newSelected,
			},
		}));
	};

	setupFactories = (elt) => {
		this.setState({
			liveFactory: {
				list: this.props.centers.list
					.filter((c) => c.isCenter && c.boxes && c.boxes.length > 0)
					.map((i) => {
						return { ...i, name: `${i.name} (${i.boxes.length} boxes)`, persisted: false };
					}),
				listLabel: this.state.liveFactory.listLabel,
				selectedLabel: this.state.liveFactory.selectedLabel,
				value: elt.centersForLive,
			},

			externalCompaniesFactory: {
				list: this.props.companies.list.data.map((i) => {
					return { ...i };
				}),
				listLabel: this.state.externalCompaniesFactory.listLabel,
				selectedLabel: this.state.externalCompaniesFactory.selectedLabel,
				value: elt.companiesForExternalSampler,
			},
			analysesMarqTumFactory: {
				list: this.props.analyses.list.data.map((i) => {
					return { ...i };
				}),
				listLabel: this.state.analysesMarqTumFactory.listLabel,
				selectedLabel: this.state.analysesMarqTumFactory.selectedLabel,
				value: elt.analysesMarqTum,
			},
			analysesPregnantFactory: {
				list: this.props.analyses.list.data.map((i) => {
					return { ...i };
				}),
				listLabel: this.state.analysesPregnantFactory.listLabel,
				selectedLabel: this.state.analysesPregnantFactory.selectedLabel,
				value: elt.analysesPregnant,
			},
		});
	};

	setOpenCache(value) {
		this.setState({ openCache: value });
		if (value) this.props.adminGetCache().then((res) => this.setState({ cacheInfos: res.payload.data }));
	}

	componentDidMount() {
		this.getAllElements();
		this.mounted = true;
	}

	componentWillUnmount() {
		this.mounted = false;
	}
	getAllElements = () => {
		this.props.adminGetAllGeneralParameters();
		this.props.getAllCenters();
		this.props.adminGetAllAnalysisLibrary();
		this.props.adminGetAllCompanies();
		this.setState({ videosLinks: this.props.general.focus.data.videos ? JSON.parse(this.props.general.focus.data.videos) : [] });
		if (this.props.general.focus && this.props.general.focus.data)
			this.setupFactories({
				centersForLive: this.props.centers.list
					.filter((c) => c.isCenter)
					.filter(
						(c) => this.props.general.focus.data.centersForLive && this.props.general.focus.data.centersForLive.split(",").includes(c.id.toString())
					)
					.map((i) => JSON.stringify({ ...i, name: `${i.name} (${i.boxes.length} boxes)`, persisted: false })),

				companiesForExternalSampler: this.props.companies.list.data
					.filter(
						(c) =>
							this.props.general.focus.data.companiesForExternalSampler &&
							this.props.general.focus.data.companiesForExternalSampler.split(",").includes(c.id.toString())
					)
					.map((c) => JSON.stringify(c)),
				analysesMarqTum:
					this.props.analyses && this.props.analyses.list && this.props.analyses.list.data && this.props.analyses.list.data.length > 0
						? this.props.analyses.list.data
								.filter(
									(a) =>
										a.catalog_code &&
										this.props.general.focus.data.analysesMarqTum &&
										this.props.general.focus.data.analysesMarqTum.split(",").includes(a.catalog_code.toString())
								)
								.map((a) => JSON.stringify(a))
						: [],
				analysesPregnant:
					this.props.analyses && this.props.analyses.list && this.props.analyses.list.data && this.props.analyses.list.data.length > 0
						? this.props.analyses.list.data
								.filter(
									(a) =>
										a.catalog_code &&
										this.props.general.focus.data.analysesPregnant &&
										this.props.general.focus.data.analysesPregnant.split(",").includes(a.catalog_code.toString())
								)
								.map((a) => JSON.stringify(a))
						: [],
			});
	};
	setVideosValues = (videos) => {
		this.setState({ videosLinks: videos });
	};

	saveFocus = (values, setSubmitting) => {
		values.centersForLive = this.state.liveFactory.value.map((c) => JSON.parse(c).id).join(",");
		values.companiesForExternalSampler = this.state.externalCompaniesFactory.value.map((c) => JSON.parse(c).id).join(",");
		values.analysesMarqTum = this.state.analysesMarqTumFactory.value.map((a) => JSON.parse(a).catalog_code).join(",");
		values.analysesPregnant = this.state.analysesPregnantFactory.value.map((a) => JSON.parse(a).catalog_code).join(",");
		values.videos = JSON.stringify(this.state.videosLinks);
		this.props
			.adminPatchGeneralParameter(values)
			.then(() => {
				setSubmitting(false);
			})
			.catch((e) => {
				setSubmitting(false);
			});
	};

	render() {
		let { focus } = this.props.general;
		if (!focus) {
			return (
				<div style={{ ...styles.adminContainer, position: "relative" }}>
					<Loader active />
				</div>
			);
		}

		return (
			<div style={styles.adminContainer}>
				<ElementFocus element={focus} list={focus} entity="Géneral" icon="settings">
					<Formik
						enableReinitialize
						initialValues={{
							ageBabyBoyPrefix: focus.data.ageBabyBoyPrefix || "",
							ageBabyGirlPrefix: focus.data.ageBabyGirlPrefix || "",
							ageBabyOtherPrefix: focus.data.ageBabyOtherPrefix || "",
							ageChildBoyPrefix: focus.data.ageChildBoyPrefix || "",
							ageChildGirlPrefix: focus.data.ageChildGirlPrefix || "",
							ageChildOtherPrefix: focus.data.ageChildOtherPrefix || "",
							ageManPrefix: focus.data.ageManPrefix || "",
							ageMaxBaby: focus.data.ageMaxBaby || 0,
							ageMaxChild: focus.data.ageMaxChild || 0,
							ageOtherPrefix: focus.data.ageOtherPrefix || "",
							ageWomanPrefix: focus.data.ageWomanPrefix || "",
							encodingFolder: focus.data.encodingFolder || "",
							encodingPdf: focus.data.encodingPdf || "",
							encodingTube: focus.data.encodingTube || "",
							urlCatalogExams: focus.data.urlCatalogExams || "",
							urlTaking: focus.data.urlTaking || "",
							helpNurse: focus.data.helpNurse ?? false,
							disableFolderSecondValidation: focus.data.disableFolderSecondValidation ?? false,
							lastUpdateCatalog: focus.data.lastUpdateCatalog || "",
							companyShortcuts: focus.data.companyShortcuts || "",
							urgencyPretreatementLimit: focus.data.urgencyPretreatementLimit || 0,
							live: focus.data.live || false,
							manualDegradation: focus.data.manualDegradation || false,
							manualDegradationMessage: focus.data.manualDegradationMessage || "",
							usualState: focus.data.usualState || false,
							analysesMarqTum: focus.data.analysesMarqTum || "",
							analysesPregnant: focus.data.analysesPregnant || "",
							checkMySecu: focus.data.checkMySecu || false,
							videos: focus.data.videos || "",
							companiesForExternalSampler: focus.data.companiesForExternalSampler || "",
							centersForLive: focus.data.centersForLive || "",
						}}
						validationSchema={schemaValidation}
						onSubmit={(values, { setSubmitting }) => {
							values.videos = JSON.stringify(this.state.videosLinks);
							this.saveFocus(values, setSubmitting);
						}}
					>
						{({ isSubmitting, errors }) => {
							return (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
												>
													Enregistrer
												</MainButton>
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={2}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="blue" ribbonLabel="Paramètres" disabled>
													<ParamsForm
														updateCompanies={(value) => this.updateFactoryValue(value, "externalCompaniesFactory")}
														externalCompaniesFactory={this.state.externalCompaniesFactory}
													/>
												</AdminDataContainer>
												<br />
												<AdminDataContainer ribbonColor="red" ribbonLabel="Préfixes et âges">
													<AgeForm />
												</AdminDataContainer>
												<br />

												<AdminDataContainer ribbonColor="purple" ribbonLabel="Motivations">
													<MotivationForm
														updateAnalysesMarqTum={(value) => this.updateFactoryValue(value, "analysesMarqTumFactory")}
														analysesMarqTumFactory={this.state.analysesMarqTumFactory}
														analysesPregnantFactory={this.state.analysesPregnantFactory}
														updateAnalysesPregnant={(value) => this.updateFactoryValue(value, "analysesPregnantFactory")}
													/>
												</AdminDataContainer>
												<br />
												<AdminDataContainer ribbonColor="orange" ribbonLabel="Disponibilité en direct">
													<AvailabilityForm
														liveFactory={this.state.liveFactory}
														updateLiveCenters={(value) => this.updateFactoryValue(value, "liveFactory")}
													/>
												</AdminDataContainer>
											</Grid.Column>

											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Liens vidéos" icon="video">
													<VideosLinksForm videosLinks={this.state.videosLinks} setVideosValues={(videos) => this.setVideosValues(videos)} />
												</AdminDataContainer>
												<br />
												<AdminDataContainer ribbonColor="green" ribbonLabel="Catalogue d'examens">
													<UrlForm />
												</AdminDataContainer>
												<br />

												<AdminDataContainer ribbonColor="olive" ribbonLabel="Autres paramètres">
													<OtherForm />
												</AdminDataContainer>
												<br />

												<AdminDataContainer ribbonColor="black" ribbonLabel="Système dégradé">
													<DegradationForm />
													<Modal
														onClose={() => this.setOpenCache(false)}
														onOpen={() => this.setOpenCache(true)}
														open={this.state.openCache}
														trigger={<Button>Cache Infos</Button>}
													>
														<Modal.Header>Cache Infos</Modal.Header>
														<Modal.Content>
															<Modal.Description>
																<Header>
																	{this.state.cacheInfos?.keys?.includes("alertResponseTime") ? (
																		<span>
																			Statut : <Icon color="red" name="exclamation circle" />
																			Mode dégradé{" "}
																		</span>
																	) : (
																		<span>
																			Statut : <Icon color="green" name="check circle" />
																			Mode normal
																		</span>
																	)}
																</Header>
																<p>Clés : {this.state.cacheInfos?.keys?.join(", ")}</p>
																<p>Stats : {JSON.stringify(this.state.cacheInfos?.stats)}.</p>
															</Modal.Description>
														</Modal.Content>
														<Modal.Actions>
															<Button
																color="black"
																onClick={() => this.props.adminFlushCache().then((res) => this.setState({ cacheInfos: res.payload.data }))}
															>
																Flush cache
															</Button>
															<Button content="Ok" labelPosition="right" icon="checkmark" onClick={() => this.setOpenCache(false)} positive />
														</Modal.Actions>
													</Modal>
												</AdminDataContainer>
												<br />
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							);
						}}
					</Formik>
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocWhiteGeneralAdmin: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		general: state.admin.general,
		centers: state.centers,
		companies: state.admin.companies,
		analyses: state.admin.analyses,
	};
};

const mapDispatchToProps = {
	adminGetAllGeneralParameters,
	adminPatchGeneralParameter,
	getAllCenters,
	searchCompanies,
	adminGetAllCompanies,
	adminGetAllAnalysisLibrary,
	adminGetCache,
	adminFlushCache,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralAdmin);
